import { API } from "utils";

export const getQueue = async () => {
    try {
        const response = await API().get("api/queues/");
        return { success: true, payload: response.data?.tiers };
    } catch (e) {
        return { success: false, payload: [], error: e };
    }
};

export const moveBlockToReviewQueue = async (data) => {
  try {
    const response = await API().post(`api/queues/move-to-review-queue`, data);
    return { success: true, payload: response.data };
  } catch (e) {
    return { success: false, payload: [], error: e };
  }
};

export const getBlockToReview = async () => {
  try {
    const response = await API().get(`api/queues/remaining-review-blocks`);
    return { success: true, payload: response.data };
  } catch (e) {
    return { success: false, payload: [], error: e };
  }
}

export const markBlockReviewed = async (reviewId, reviewNote) => {
  try {
    const response = await API().put(`api/queues/mark-block-as-reviewed/${reviewId}`, { review_note: reviewNote });
    return { success: true, payload: response.data };
  } catch (e) {
    return { success: false, payload: [], error: e };
  }
}

export const isBlockInReviewQueue = async (parentAdblockId) => {
  try {
    const response = await API().get(`api/queues/get-non-reviewed-parent/${parentAdblockId}`);
    return { success: true, payload: response.data };
  } catch (e) {
    return { success: false, payload: [], error: e };
  }
}